<template lang="html">
  	<div class="home">
	    <common-header></common-header>
	    <list-kv :kvArray="kvItems"></list-kv>
	    <activity :activityArray="activityItems"></activity>
	    <quanyi></quanyi>
	    <exchange :exchangeArray="exchangeItems"></exchange>
	    <common-footer></common-footer>
	    <to-top></to-top>
  	</div>
</template>

<script>
	//组件
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	import toTop from '../../components/common/toTop'
	import quanyi from '../../components/home/quanyi'
	import activity from '../../components/home/activity'
	import exchange from '../../components/home/exchange'
	//接口
	import Server from '../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		kvItems:[],
		  		activityItems:[],
		  		exchangeItems:[],
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  		toTop,
	  		quanyi,
	  		activity,
	  		exchange,
	  	},
	  	methods:{
	  		//根据URL获取图片路径、父类、样式类型等
		    getPidNumAndPtype :function(url,targetType){
		    	if(url.indexOf(targetType) > -1){
		    		let type = url.substring(parseInt(url.indexOf(targetType)+parseInt(targetType.length+1)));
			    	if(type.indexOf('&')>-1){
			    		return type.slice(0,type.indexOf('&'));
			    	}else{
			    		return type;
			    	}
		    	}else{
		    		let type = '';
		    		return type;
		    	}	
		    }
	  	},
	  	created(){
	  		//如果在PC端打开，则跳转到PC版网址
			var ua = navigator.userAgent.toLowerCase();
			if (!(/mobile|android|iphone|ipad|phone|micromessenger/i.test(ua))) {
			    window.location.href = "https://jf.gtja.com/pc/cfClub/index/index.html?type=jhjf";
			}
	  		//首页KV数据
	  		Server.listConfig('indexBanner').then((result)=>{
	  			if(result.code == '0'){
	  				this.kvItems = result.msg.types;
	  			}
	  		})
	  		//首页精彩活动
	  		Server.listConfig('indexActivity').then((result)=>{
	  			if(result.code == '0'){
	  				let activityItems = result.msg.types
	  				activityItems.map((item,index)=>{
	  					// item.LINK_URL = 'https://jf.gtja.com/pc/cfClub/activityDetail/index.html?infoId=593370844317911&typeName=会员公益活动';
	  					item.INFO_ID = this.getPidNumAndPtype(item.LINK_URL,'infoId');
	  					item.TYPE_CODE = '9902001|9902002|9902003|9902004|9902005';
	  				})
	  				this.activityItems = activityItems;
	  				
	  			}
	  		})
	  		//首页专属周边
	  		Server.listConfig('indexExchange').then((result)=>{
	  			if(result.code == '0'){
	  				this.exchangeItems = result.msg.types;
	  				// console.log(this.exchangeItems);
	  			}
	  		})
	  	},
	}
</script>

<style lang="less" scoped>
	.home{
		// padding-bottom:250px;
		
	}
</style>


// WEBPACK FOOTER //
// src/container/homePage/home.vue